export default {
    ERROR_WHILE_APPLYING_LAYOUT: "Не удалось применить выбранную форму графа. Граф слишком большой",
    ERROR_WHILE_WEB_GL2_GRAPH_CONFIGURATION: "Не удалось отобразить граф. Ваш браузер не поддерживает WebGL2",
    ERROR_WHILE_LOAD_GRAPH: "Произошла ошибка при попытке отобразить граф",
    HAS_UNSAVED_DATA: "У вас есть несохраненные данные.\nВы уверены, что хотите уйти?",
    CONFIRM_EXIT: "Подтверждение выхода"
};
